import type { UserRole } from "./types";

export type Permission =
  | "dashboard.view"

  | "comandas.view"
| "comandas.create"
| "comandas.edit"
| "comandas.delete"
| "comandas.close"
| "comandas.reopen"

  | "pedidos.view"
  | "pedidos.create"
  | "pedidos.edit"

  | "estoque.view"
  | "estoque.edit"
  | "estoque.delete"

  | "quadras.view"
  | "quadras.create"
  | "quadras.edit"
  | "quadras.delete"
  | "quadras.payment"

  | "turmas.view"
  | "turmas.create"
  | "turmas.edit"
  | "turmas.delete"
  | "turmas.payment"

  | "clientes.view"
  | "clientes.create"
  | "clientes.edit"
  | "clientes.delete"

  | "financeiro.view"
  | "financeiro.edit"
  | "financeiro.close"

  | "escola.view"
  | "escola.manage"

  | "funcionarios.view"
  | "funcionarios.create"
  | "funcionarios.edit"
  | "funcionarios.delete"

  | "audit.view"

  | "settings.manage";


const ALL_PERMISSIONS: Permission[] = [
  "dashboard.view",

  "comandas.view",
"comandas.create",
"comandas.edit",
"comandas.delete",
"comandas.close",
"comandas.reopen",

  "pedidos.view",
  "pedidos.create",
  "pedidos.edit",

  "estoque.view",
  "estoque.edit",
  "estoque.delete",

  "quadras.view",
  "quadras.create",
  "quadras.edit",
  "quadras.delete",
  "quadras.payment",

  "turmas.view",
  "turmas.create",
  "turmas.edit",
  "turmas.delete",
  "turmas.payment",

  "clientes.view",
  "clientes.create",
  "clientes.edit",
  "clientes.delete",

  "financeiro.view",
  "financeiro.edit",
  "financeiro.close",

  "escola.view",
  "escola.manage",

  "funcionarios.view",
  "funcionarios.create",
  "funcionarios.edit",
  "funcionarios.delete",

  "audit.view",

  "settings.manage",
];


const ROLE_PERMISSIONS: Record<
  UserRole,
  Permission[]
> = {
  administrador:
    ALL_PERMISSIONS,

  gerente: [
    "dashboard.view",

    "comandas.view",
"comandas.create",
"comandas.edit",
"comandas.delete",
"comandas.close",

    "pedidos.view",
    "pedidos.create",
    "pedidos.edit",

    "estoque.view",
    "estoque.edit",

    "quadras.view",
    "quadras.create",
    "quadras.edit",
    "quadras.delete",
    "quadras.payment",

    "turmas.view",
    "turmas.create",
    "turmas.edit",
    "turmas.delete",
    "turmas.payment",

    "clientes.view",
    "clientes.create",
    "clientes.edit",
    "clientes.delete",

    "financeiro.view",
    "financeiro.edit",
    "financeiro.close",

    "escola.view",

    "funcionarios.view",

    "audit.view",
  ],

  professor: [
  "dashboard.view",

  "quadras.view",

  "turmas.view",
  "turmas.create",
  "turmas.edit",
  "turmas.payment",

  "clientes.view",
  "clientes.create",

  "escola.view",
  "escola.manage",
],

  caixa: [
    "dashboard.view",

    "comandas.view",
"comandas.create",
"comandas.edit",
"comandas.close",

    "pedidos.view",
    "pedidos.create",
    "pedidos.edit",

    "quadras.view",
    "quadras.create",
    "quadras.edit",
    "quadras.payment",

    "turmas.view",
    "turmas.payment",

    "clientes.view",
    "clientes.create",
    "clientes.edit",

    "financeiro.view",
  ],

  cozinha: [
    "pedidos.view",
    "pedidos.edit",
  ],

  funcionario: [
  "dashboard.view",

  "comandas.view",
  "comandas.create",
  "comandas.edit",
  "comandas.close",

  "estoque.view",

  "quadras.view",
  "quadras.create",
  "quadras.edit",
  "quadras.payment",

  "turmas.view",

  "clientes.view",
  "clientes.create",
  "clientes.edit",
],
};


export function hasPermission(
  role: UserRole | null | undefined,
  permission: Permission,
) {
  if (!role) {
    return false;
  }

  return (
    ROLE_PERMISSIONS[
      role
    ]?.includes(
      permission,
    ) ?? false
  );
}
